var render = function render(){var _vm=this,_c=_vm._self._c;return _c('path',{staticClass:"cls-1",attrs:{"d":"M1462,154h3v3h-3v-3Zm4,0h13v3h-13v-3Zm-4,5h3v3h-3v-3Zm4,0h13v3h-13v-3Zm-4,5h3v3h-3v-3Zm4,0h13v3h-13v-3Z","transform":"translate(-1462 -154)"}})
}
var staticRenderFns = []

export { render, staticRenderFns }